{
  "periods.toolbar": "Timeline controls",
  "periods.viewport_start": "Visible start",
  "periods.viewport_end": "Visible end",
  "periods.apply": "Apply",
  "periods.navigate": "Navigate",
  "periods.custom": "Custom",
  "periods.months_one": "1 month",
  "periods.months_other": "{{count}} months",
  "periods.years_one": "1 year",
  "periods.years_other": "{{count}} years",
  "periods.invalid_range": "Enter a valid start and end, no more than 15 years apart.",
  "periods.range_limited": "Showing a 15-year window. Use the range controls to see the remaining periods.",
  "periods.continues_before": "Continues before the visible range",
  "periods.continues_after": "Continues after the visible range",
  "periods.snap_today": "Aligned to Today · {{date}}",
  "periods.snap_status": "{{range}} · {{snap}}",
  "periods.planned_start": "Planned start",
  "periods.planned_end": "Planned end",
  "periods.quick_dates": "Planned dates",
  "periods.save": "Save",
  "periods.cancel": "Cancel",
  "periods.unsaved_dates": "Discard unsaved planned dates?",
  "periods.discard": "Discard changes",
  "periods.keep_editing": "Keep editing",
  "periods.date_error": "Dates could not be saved. Your changes are still available.",
  "periods.dates_saved": "Planned dates saved.",
  "periods.drop_needs_dates": "The known date is outside this view. Adjust the planned dates to place this period.",
  "periods.gesture_hint": "Drag to move · Drag a visible end to resize · Shift for precision · Arrow keys move by one day",
  "periods.unsaved_dates_title": "Unsaved planned dates",
  "periods.unsaved_dates_description": "Save your dates before leaving, discard the changes, or keep editing."
}
